import { Component, DestroyRef, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { RenderGridComponent } from '../render-grid/render-grid.component';
import { ActivatedRoute } from '@angular/router';
import { getStorage, ref } from "firebase/storage";
import localforage from 'localforage';
import { BaseState } from '../../reducers';
import { Store } from '@ngrx/store';
import { selectUserId } from '../../users/store/user.selector';
import { filter, map, take ,interval } from 'rxjs'; import { FirebaseApp } from '@angular/fire/app';
import { getDownloadURL } from '@angular/fire/storage';
import { HttpClient } from '@angular/common/http';
import { Firestore } from '@angular/fire/firestore';
import { FirebaseFirestoreService } from '../../services/firebase-firestore.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { resetEditorState, saveRenderToFirebase } from '../store/editor.actions';
import { FirebaseRenderData } from '../../services/firebase.model';
import { RawImageDataLoaderService } from '../../services/image-loader.service';
import { RenderDataActionsService } from '../../services/render-data-actions.service';

enum LoadingState {
  Idle = "Idle",
  Downloading = "Downloading",
  Decompressing = "Decompressing"
}

@Component({
  selector: 'app-editor-container',
  standalone: true,
  imports: [RenderGridComponent, ProgressSpinnerModule],
  templateUrl: './editor-container.component.html',
  styleUrl: './editor-container.component.scss'
})
export class EditorContainerComponent implements OnDestroy {
  firebaseApp = inject(FirebaseApp)
  firestore = inject(Firestore)
  renderDataActionService = inject(RenderDataActionsService)

  userId$ = this.store.select(selectUserId)
  loading = true
  destroy = inject(DestroyRef)
  loadingState: LoadingState = LoadingState.Idle

  loadRender$ = this.userId$.pipe(
    filter((userId) => !!userId),
    take(1),
    map(async (userId): Promise<{buf: ArrayBuffer, userId: string, renderData: FirebaseRenderData}> => {
      this.loadingState = LoadingState.Downloading
      const renderId = this.activatedRoute.snapshot.params['id']
      const renderData = await this.firestoreService.getRenderData(userId as string,renderId)
      const baseDataId = renderData.baseDataId
      const localRender = await localforage.getItem<ArrayBuffer>(`render/${baseDataId}`)
      if (localRender !== null) {
        return {buf: localRender, userId: userId as string, renderData}
      }
      const storage = getStorage(this.firebaseApp, "gs://completed-renders");
        const url = await getDownloadURL(ref(storage, `${userId}/${baseDataId}`))

      return new Promise((resolve) => {
        this.httpClient.get(url, {responseType: 'arraybuffer'}).subscribe((blob) => {
          localforage.setItem(`render/${baseDataId}`, blob).then(() => {
            resolve({buf: blob, userId: userId as string, renderData})
          })
        })
      })
    }),
    map(async (result) => {
      const data = await result
      this.loadingState = LoadingState.Decompressing
      await this.imageLoaderService.loadImageFromFile(data.buf)
      this.renderDataActionService.setRenderData(data.renderData)
      this.loadingState = LoadingState.Idle
      return true
    })
  )

  autoSave = interval(60000).pipe(
    takeUntilDestroyed(),
    map(() => this.store.dispatch(saveRenderToFirebase())),
  )

  @HostListener('window:beforeunload')
  saveChanges(){
    this.store.dispatch(saveRenderToFirebase())
  }

  ngOnDestroy(): void {
    this.store.dispatch(saveRenderToFirebase())
    //this.imageDrawService.releaseMemory()
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<BaseState>,
    private httpClient: HttpClient,
    private firestoreService: FirebaseFirestoreService,
    private imageLoaderService: RawImageDataLoaderService,
  ) {
    this.loadRender$.subscribe(async (output) => {
      const loaded = await output
      this.loading = !loaded
    })
    this.autoSave.subscribe()
    this.store.dispatch(resetEditorState())
  }
}
